const { prop, pick } = require("ramda");

(function() {
  angular
    .module("ticketco/ticketbuyer/gift_cards")
    .factory("BalanceItemsPersistence", BalanceItemsPersistence);

  function BalanceItemsPersistence($q, $http) {
    function url(obj) {
      return "/orders/" + obj.order_uuid + "/balance_items";
    }

    function check_balance_url() {
      return "/balance_items";
    }

    var unwrapResponse = prop("data");

    function validateResponse(res) {
      if (res.errors.length > 0) {
        return $q.reject(res.errors);
      } else {
        return res;
      }
    }

    var permittedParams = pick(["ref_number", "token", "type"]);

    function verify(obj) {
      return $http
        .post(url(obj), permittedParams(obj))
        .then(unwrapResponse)
        .then(validateResponse)
        .then(function(res) {
          res.ref_number = obj.ref_number;
          return res;
        });
    }

    function checkBalance(obj) {
      return $http
        .post(check_balance_url(), permittedParams(obj))
        .then(unwrapResponse)
        .then(validateResponse);
    }

    return {
      verify: verify,
      checkBalance: checkBalance,
    };
  }
})();
